// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'third/jquery.downloadCenterFilter';

export default class DownloadCenterFilter extends WebComponent {
	didMount() {
        $(this.element).downloadCenterFilter();
    }
}


// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/components/DownloadCenterFilter.js